<span class="checkbox-custom">
  <input
    type="checkbox"
    [id]="checkboxId"
    [ngModel]="checked"
    (ngModelChange)="onChange($event)"
    [disabled]="disabled"
    class="checkbox-custom__input"/>
  <label
    [for]="checkboxId"
    (click)="onCheckboxClick($event)"
    class="checkbox-custom__icon"
    [ngClass]="{ 'checkbox-custom__icon--small' : size === 'small' }">
    <span
      *ngIf="checked; else unchecked"
      [inlineSVG]="'assets/images/icons/icon-checkbox-on.svg'">
    </span>
    <ng-template #unchecked>
      <span
        [inlineSVG]="'assets/images/icons/icon-checkbox.svg'">
      </span>
    </ng-template>
  </label>
</span>
